import _slicedToArray from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
// Copyright 2017-2021 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { map } from '@polkadot/x-rxjs/operators';
import { memo } from "../util/index.mjs";

function createDerive(api, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _slicedToArray(_ref2[0], 3),
      hasBabe = _ref2$[0],
      epochDuration = _ref2$[1],
      sessionsPerEra = _ref2$[2],
      _ref2$2 = _ref2[1],
      activeEra = _ref2$2.activeEra,
      activeEraStart = _ref2$2.activeEraStart,
      currentEra = _ref2$2.currentEra,
      currentIndex = _ref2$2.currentIndex,
      validatorCount = _ref2$2.validatorCount;

  return {
    activeEra: activeEra,
    activeEraStart: activeEraStart,
    currentEra: currentEra,
    currentIndex: currentIndex,
    eraLength: api.registry.createType('BlockNumber', sessionsPerEra.mul(epochDuration)),
    isEpoch: hasBabe,
    sessionLength: epochDuration,
    sessionsPerEra: sessionsPerEra,
    validatorCount: validatorCount
  };
}

function queryAura(api) {
  return api.derive.session.indexes().pipe(map(function (indexes) {
    var _api$consts$staking;

    return createDerive(api, [[false, api.registry.createType('u64', 1), // we may have aura without staking (permissioned)
    ((_api$consts$staking = api.consts.staking) === null || _api$consts$staking === void 0 ? void 0 : _api$consts$staking.sessionsPerEra) || api.registry.createType('SessionIndex', 1)], indexes]);
  }));
}

function queryBabe(api) {
  return api.derive.session.indexes().pipe(map(function (indexes) {
    var _api$consts$staking2;

    return createDerive(api, [[true, api.consts.babe.epochDuration, // we may have babe without staking (permissioned)
    ((_api$consts$staking2 = api.consts.staking) === null || _api$consts$staking2 === void 0 ? void 0 : _api$consts$staking2.sessionsPerEra) || api.registry.createType('SessionIndex', 1)], indexes]);
  }));
}
/**
 * @description Retrieves all the session and era query and calculates specific values on it as the length of the session and eras
 */


export function info(instanceId, api) {
  return memo(instanceId, function () {
    return api.consts.babe ? queryBabe(api) : queryAura(api);
  });
}